class AudioCtx extends Weaver.Node

  @className = 'AudioCtx'

  constructor: (id) ->
    super(id)

  create: (name = "New Audio Context") ->
    type = await Weaver.Node.firstOrCreate('AudioContext')
    @set('name', name)
    @relation('type').add(type)
    @save()

export default AudioCtx
